// extracted by mini-css-extract-plugin
export var quantityInput = "_m9-0";